import React from "react";
import { Link } from "react-router-dom";

export const Footer = ({ className = "" }) => (
  <footer
    data-testid="global-footer"
    className={`relative z-10 px-8 py-8 border-t border-[var(--mirror-border)] ${className}`}
  >
    <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[var(--mirror-text-3)]">
      <span data-testid="footer-copyright">© 2026 Gnosis Dynamics LLC</span>
      <nav className="flex items-center gap-6">
        <Link
          data-testid="footer-terms-link"
          to="/terms"
          className="tracking-wide hover:text-[var(--mirror-text)] transition-opacity duration-500"
        >
          Terms of Service
        </Link>
        <Link
          data-testid="footer-privacy-link"
          to="/privacy"
          className="tracking-wide hover:text-[var(--mirror-text)] transition-opacity duration-500"
        >
          Privacy Policy
        </Link>
      </nav>
    </div>
  </footer>
);
